import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const StatusDot = ({ status, children })=>/*#__PURE__*/ _jsx("span", {
        className: `statusDot statusDot--${status}`,
        children: children
    });
export default StatusDot;
